// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --iconButtonSizeSmall: 1.5rem;
  --iconButtonSizeMedium: 2rem;
  --iconButtonSizeLarge: 2.5rem;
}

:host.icon-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  padding: 0;
  margin: 0;
  cursor: pointer;
  background: rgb(0, 0, 0, 0%);
  border: none;
  border-radius: 0.25rem;
}

:host.icon-button > * {
    pointer-events: none;
  }

:host.icon-button--small {
    width: 1.5rem;
    height: 1.5rem;
  }

:host.icon-button--large {
    width: 2.5rem;
    height: 2.5rem;
  }

:host.icon-button--circle {
    border-radius: 50%;
  }

:host.icon-button:hover {
    background: rgb(0, 0, 0, 8%);
  }

:host.icon-button:active,
  :host.icon-button[aria-expanded='true'],
  :host.icon-button[aria-pressed='true'] {
    background: rgb(0, 0, 0, 10%);
  }

:host.icon-button--outline {
    background: #fff;
    border: 1px solid #e5e6e6;
  }

:host.icon-button--outline:hover {
      background: #f6f7f8;
    }

:host.icon-button--outline:active,
    :host.icon-button--outline[aria-expanded='true'],
    :host.icon-button--outline[aria-pressed='true'] {
      background: #e5e6e6;
    }

.icon-button__content {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  white-space: nowrap;
  clip-path: inset(50%);
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
